import { render, staticRenderFns } from "./grid-transfer-direction.vue?vue&type=template&id=f9fbf3e0&"
import script from "./grid-transfer-direction.ts?vue&type=script&lang=js&"
export * from "./grid-transfer-direction.ts?vue&type=script&lang=js&"
import style0 from "./grid-transfer-direction.vue?vue&type=style&index=0&id=f9fbf3e0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports